
function isArray(o) {
    if (typeof o === 'undefined') return false;
    let t = Object.prototype.toString.call(o)
    return t === '[object Array]'
}

export default isArray